'use client'

import { useAction } from 'next-safe-action/hooks'

import { getPhoneNumber as _getPhoneNumber } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

export type PhoneVerificationResult = {
  certNum: string
  phoneNumber: string
}

export const useGetPhoneNumber = ({
  onSuccess,
}: {
  onSuccess: ({ certNum, phoneNumber }: PhoneVerificationResult) => void
}) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_getPhoneNumber, {
    onSuccess: ({ data }) => {
      if (data) {
        onSuccess(data)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const getPhoneNumber = (certNum: string) => {
    action.execute({ certNum })
  }

  return {
    getPhoneNumber,
  }
}
